import React from "react";
import RedoIcon from "@mui/icons-material/Redo";
import { IconButton, Box, Typography } from "@mui/material";
import { PXDX } from "../Constants/PolicyTranslationConstants";

const DuplicateRowFragment = ({ editable, params, value, duplicateRow }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
    >
      {value}
      <IconButton
        aria-label="duplicate"
        size="small"
        disabled={!editable}
        onClick={() => {
          duplicateRow(params.row.index);
        }}
      >
        <RedoIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default DuplicateRowFragment;
